export interface DiscountCard {
  code: string
  description: string
  name: string
  requires_passenger_identifier: boolean
}

export interface Passenger {
  id: string
  type: string
  description?: string
  discount_cards?: DiscountCard[]
  travel_passes?: Array<{ code: string }>
}

export interface PassengerType {
  code: string
  description: string
  sequence_number: number
}

// The full planner fetches these from /api/v3/fare/passenger-types; the list and
// order are stable, and the visible labels come from the `descriptions.passengerNames.*`
// i18n keys (not the API), so we hardcode them here. Order matches the Figma design:
// Voksen, Barn 0–5, Barn 6–17, Student, Honnør, Vernepliktig, Ledsager.
export const PASSENGER_TYPES: PassengerType[] = [
  { code: 'ADT', description: '', sequence_number: 0 },
  { code: 'CHD', description: '', sequence_number: 1 },
  { code: 'YOU', description: '', sequence_number: 2 },
  { code: 'STU', description: '', sequence_number: 3 },
  { code: 'SEN', description: '', sequence_number: 4 },
  { code: 'CON', description: '', sequence_number: 5 },
  { code: 'COM', description: '', sequence_number: 6 },
]
